import { render, staticRenderFns } from "./PicklDetails.vue?vue&type=template&id=0d7b8cc0&"
import script from "./PicklDetails.vue?vue&type=script&lang=ts&"
export * from "./PicklDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d7b8cc0')) {
      api.createRecord('0d7b8cc0', component.options)
    } else {
      api.reload('0d7b8cc0', component.options)
    }
    module.hot.accept("./PicklDetails.vue?vue&type=template&id=0d7b8cc0&", function () {
      api.rerender('0d7b8cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PicklDetails.vue"
export default component.exports